module.exports = __webpack_public_path__ + "static/media/S1_00016.aa065a49.jpg";